export default "__VITE_ASSET__CPJL6cdf__"